<div class="py-6 px-[2vw]">
  <router-outlet></router-outlet>
</div>
